import { render, staticRenderFns } from "./SearchPopup.vue?vue&type=template&id=f18965be&scoped=true&"
import script from "./SearchPopup.vue?vue&type=script&lang=js&"
export * from "./SearchPopup.vue?vue&type=script&lang=js&"
import style0 from "./SearchPopup.vue?vue&type=style&index=0&id=f18965be&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f18965be",
  null
  
)

export default component.exports